'use client';

import styles from '~/styles/components/author/author-header.module.scss';
import RichText from '~/components/rich-text';
import { numberWithCommas } from 'sdk';
import { Author } from 'types';
import { AuthorEditableFields, updateAuthorField } from '~/lib/helpers/authors';

import Pill from '~/components/pill';
import moment from 'moment';

import AuthorImage from '~/components/author/author-image';
import AuthorLinks from '~/components/author/author-links';
import { useGlobalState } from '../../state';

interface AuthorHeaderProps {
  author: Author;
  genres: any;
  photo_url: string;
  numTitles: number;
}

export default function AuthorHeader({
  author,
  genres,
  photo_url,
  numTitles,
}: AuthorHeaderProps) {
  const { state } = useGlobalState();
  const user = state?.user?.data;
  const isAdmin = state?.user?.data?.isAdmin;
  const category_url = 'https://pangobooks.com/category/';

  async function handleSaveEditorState(
    _stringifiedEditorState: string,
    updateField: AuthorEditableFields
  ) {
    await updateAuthorField({
      authorId: author?.id,
      updated_by: user?.name,
      data: {
        [updateField]: _stringifiedEditorState,
      },
    });
  }

  return (
    <>
      {isAdmin && author?.updated_by && (
        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
          {`Last updated by  ${author?.updated_by}  ${moment(author?.updated_at?.['_seconds'] * 1000).fromNow()} `}
        </div>
      )}
      <div className={styles['header']}>
        <div className={styles['header-image']}>
          <AuthorImage
            author={author}
            user={user}
            photo_url={photo_url}
            isAdmin={isAdmin}
          />
          <div className={styles['seller-stats']}>
            <div className={styles['seller-stats-group']}>
              <h3>Books Sold </h3>{' '}
              <span>{numberWithCommas(author?.sold)} </span>
            </div>

            <div className={styles['seller-stats-group']}>
              <h3>Copies for Sale </h3>
              <span>{numberWithCommas(author?.copies)} </span>
            </div>

            <div className={styles['seller-stats-group']}>
              <h3># of Titles </h3> <span>{numTitles} </span>
            </div>
          </div>
          <AuthorLinks author={author} user={user} isAdmin={isAdmin} />
        </div>

        <div className={styles['header-content']}>
          <h1>{author?.fullname} </h1>
          <RichText
            initialEditorState={author?.rich_description || undefined}
            initialText={
              author?.rich_description ? undefined : author?.description
            }
            editable={true}
            handleSave={(_stringifiedEditorState) =>
              handleSaveEditorState(_stringifiedEditorState, 'rich_description')
            }
            key={author?.id + 'desc1'}
          />

          {/* {genres && (
            <>
              <h3 className={styles['category-title']}>Categories</h3>
              <div className={styles['category-row']}>
                {genres.map((g) =>
                  g?.value != null ? (
                    <div className={styles['category-pill']}>
                      <Pill
                        key={g?.value}
                        text={g?.display}
                        small={true}
                        link={{ href: category_url + g?.slug }}
                      />
                    </div>
                  ) : null
                )}
              </div>
            </>
          )} */}


          {author?.publisher && (
            <>
              <div className={styles['publisher-title']}>Publisher</div>
              <div className={styles['publisher-content']}>
                {author?.publisher}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
